'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sk_SK = require('../../date-picker/locale/sk_SK');

var _sk_SK2 = _interopRequireDefault(_sk_SK);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _sk_SK2['default'];